module.exports = __webpack_public_path__ + "media/images/shared/suppliers/AUGER-058f73dbf8a967dcc1cd6a98fc38503e.jpg";